export default class HttpRoute {

    /**
     * Route zawiere segmenty rozpoczynające się od : (np. /:id
     * Które zostaną zamienione na podane argumenty.
     * @param str
     */
    public static of(str: string): HttpRoute{
        return new HttpRoute(str);
    }

    private path:string;

    constructor(path: string) {
        this.path = path;
    }

    public build(...args: string[]){

        let parts = this.path.split('/');
        let i:number = 0;

        let res:string[] = [];
        for (const part of parts) {
            if(!part.startsWith(":")){
                res.push(part);
            }else{
                res.push(args[i]);
                i++;
            }
        }

        return res.join("/");
    }

}